import React from "react";
import { AuthContext } from "./AuthContext";

interface IHasRightProps {
    right: string;
    not?: boolean;
}

class HasRight extends React.Component<IHasRightProps> {
    public render() {
        return (
            <AuthContext.Consumer>
                {ctx => (this.props.right && (this.props.not ? !ctx.hasRight(this.props.right) : ctx.hasRight(this.props.right))) ? this.props.children : null}
            </AuthContext.Consumer>
        );
    }
}

export default HasRight;
